import React, { useEffect, useState } from 'react'
import Table from '../components/table'
import SimpleHeader from '../components/simple_header'
import { GET_COMMANDS } from '../services/devices';
import { showNotification } from '@mantine/notifications';
import { getDeviceTitle } from '../utility/util';
import moment from 'moment';

function Commands({}){
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);

    const loadItems = () => {
        setLoading(true);
        
        GET_COMMANDS()
        .then((res) => {
            setLoading(false);
            setItems(res);
        })
        .catch((err) => {
            setLoading(false);
            showNotification({ message: err.message, color: 'red' })
        })
    }

    useEffect(loadItems, [])

    return <>
        <SimpleHeader
            title="Comandos Enviados"
        />
        <Table
            data={items}
            columns={[
                { title: "Data", key: "createdAt", render: (item) => moment(item.createdAt).format("DD/MM/YYYY HH:mm:ss") },
                { title: "Comando", key: "type", render: (item) => ({
                    'device-configs': "Configuração",
                    'device-block': "Bloqueio",
                    'device-unblock': "Desbloqueio",
                })[item.type] ?? item.type },
                { title: "Dispositivo", key: "device", render: (item) => getDeviceTitle(item.device) },
                { title: "Status", key: "status", render: (item) => ({
                    'trigger': "Enviado",
                    'failed': "Falhou",
                    'scheduled': "Agendada",
                    'sending': "Enviando",
                    'delivered': "Recebida",
                })[item.status] ?? item.status },
                { title: "Identificador", key: "dt", render: item => item?.data?.description },
            ]}
        />
    </>

}

export default Commands;